/* eslint-disable @next/next/no-img-element */
'use client'; // Error components must be Client Components - https://nextjs.org/docs/app/building-your-application/routing/error-handling

import * as Sentry from '@sentry/browser';

import { ErrorPage } from '../components/ErrorPage/ErrorPage';
import clientConfig from '../client/config';
import { initClientSideSentry } from '../utils/sentry';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

if (typeof window !== 'undefined') {
  initClientSideSentry();
}

export default function Error({ error }: { error: Error }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const { t } = useTranslation();

  return (
    <>
      <div style={{ borderBottom: '1px #ccc solid', backgroundColor: '#fff' }}>
        <div
          style={{
            maxWidth: '1240px',
            margin: '0 auto',
            padding: '6px 18px',
            height: '59px',
          }}
        >
          <a href={clientConfig.justGivingRootUrl} style={{ height: '100%' }}>
            <img
              alt="logo"
              style={{ height: '100%', width: '153px' }}
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiIHZpZXdCb3g9Ii01MzQgMzgzIDIxMSAzNiI+DQogICAgPHBhdGggZmlsbD0iI2FjMjliNSIgZD0iTS00NTMuMiAzOTcuOGMwIDguMSA2LjYgMTQuOCAxNC44IDE0LjggOC4yIDAgMTQuOC02LjYgMTQuOC0xNC44IDAtMS4xLS4xLTIuMi0uNC0zLjJoLTEwLjRsLTYuMSA2aDguM2MtMS4xIDIuNC0zLjUgNC4xLTYuNCA0LjEtMy44IDAtNy0zLjEtNy02LjkgMC0zLjggMy4xLTYuOSA3LTYuOSAxLjQgMCAyLjcuNCAzLjggMS4xbDUuNi01LjZjLTIuNi0yLjEtNS44LTMuMy05LjQtMy4zLTcuOS0uMS0xNC42IDYuNS0xNC42IDE0Ljd6bTMxLjctNy45aDcuM1Y0MTJoLTcuM3YtMjIuMXptMC02LjRoNy4zdjQuNGgtNy4zdi00LjR6bTIzLjggMjguNmw4LjctMjIuMmgtNy43bC00LjIgMTIuMy00LjEtMTIuM2gtNy44bDguNyAyMi4xLjEuMmg2LjN6bTEwLjEtMjIuMmg3LjNWNDEyaC03LjN2LTIyLjF6bTAtNi40aDcuM3Y0LjRoLTcuM3YtNC40em0zMC4xIDI4LjR2LTE0LjFjMC01LjItMy04LjQtNy44LTguNC0yLjIgMC00IC44LTUuNiAyLjRsLTItMmgtNS4xdjIyLjFoNy4zdi0xMi4yYzAtMS42LjUtMy41IDMtMy41IDEuOSAwIDIuOCAxLjIgMi44IDMuNXYxMi4yaDcuNHptLTE2Ni43LjRjNi42IDAgMTAuMy0zLjggMTAuMy0xMC40di0xOC4zaC03LjZ2MTguMWMwIDIuNS0uOSAzLjctMi45IDMuNy0xLjUgMC0yLjgtLjctNC40LTIuNWwtLjMtLjMtNSA0LjkuNC41YzIuNSAyLjkgNS42IDQuMyA5LjUgNC4zem0xNzkuNC4zYy0xLjkgMC0zLjYtLjMtNS4zLTEuMWwtNC44IDQuOC43LjRjMi44IDEuNSA2LjEgMi4yIDkuNSAyLjIgOC40IDAgMTIuNC00LjMgMTIuNC0xMi4ydi0xNi44aC01LjNsLTEuOSAxLjljLTEuOC0xLjUtMy43LTIuMy02LjItMi4zLTUgMC0xMCAzLjYtMTAgMTAuNHYuMWMwIDYuOCA1IDEwLjQgMTAgMTAuNCAyLjQgMCA0LjItLjcgNS45LTIuMS0uMyAyLjYtMS45IDQuMy01IDQuM3ptLjgtOC4yYy0yLjcgMC00LjctMS44LTQuNy00LjR2LS4xYzAtMi42IDItNC40IDQuNy00LjRzNC43IDEuOCA0LjcgNC40di4xYzAgMi41LTIgNC40LTQuNyA0LjR6bS0xNjcuNS0xNC41VjQwNGMwIDUuMiAzIDguNCA3LjggOC40IDIuMiAwIDQtLjggNS42LTIuNGwyIDJoNS4xdi0yMi4xaC03LjN2MTIuMmMwIDEuNi0uNSAzLjUtMi45IDMuNS0xLjkgMC0yLjgtMS4yLTIuOC0zLjV2LTEyLjJoLTcuNXptNTYuMiA2LjR2LTYuNGgtNC45di02LjNoLTcuM3Y2LjNoLTIuNXY2LjRoMi41djljMCA0LjcgMi4yIDYuOSA2LjggNi45IDEuOSAwIDMuNS0uNCA1LTEuM2wuNC0uMnYtNi4zbC0xLjEuNmMtLjguNC0xLjcuNy0yLjYuNy0uOSAwLTEuMi0uMy0xLjItMS4zdi04LjFoNC45em0tMjQuMiAxMC42Yy0xLjggMC0zLjktLjgtNS45LTIuMWwtNCA0LS4xLjEuNC4zYzIuNyAyLjEgNi4xIDMuMyA5LjUgMy4zIDUuNCAwIDguNy0yLjcgOC43LTcuM3YtLjFjMC00LjUtNC40LTYtNi44LTYuOGwtLjctLjJjLTEuNy0uNi0zLjMtMS4xLTMuMy0xLjh2LS4xYzAtLjcuOS0xIDEuNy0xIDEuMiAwIDIuOC41IDQuNSAxLjRsNC4yLTQuMi0uMy0uMmMtMi40LTEuNi01LjUtMi42LTguMi0yLjYtNSAwLTguMyAyLjktOC4zIDcuM3YuMWMwIDQuMyAzLjQgNS45IDYuNyA2LjguMy4xLjYuMi44LjIgMS44LjUgMy4zIDEgMy4zIDEuN3YuMWMtLjIuOS0xLjMgMS4xLTIuMiAxLjF6bTE0OC43LTE2aDF2Mi41aDEuMnYtMi41aDF2LTFoLTMuM3Yxem02LjQtMWwtLjggMS4yLS44LTEuMmgtMS4ydjMuNWgxLjJ2LTEuOGwuNS44aC42bC41LS44djEuOGgxLjJ2LTMuNWgtMS4yeiIvPg0KPC9zdmc+"
            />
          </a>
        </div>
      </div>
      <ErrorPage imageUrl="https://images.justgiving.com/image/error_500.gif">
        <h1 className="cp-heading-medium">{t('page.error500.heading')}</h1>
        <p>{t('page.error500.message')}</p>
        <a className="cp-text-link" href={clientConfig.justGivingRootUrl}>
          {t('page.error500.linkWording')}
        </a>
      </ErrorPage>
    </>
  );
}
